export const UI = "ui";
export type UI = typeof UI;

export type UIStateType = {
	isDarkMode: boolean;
};

export const TOGGLE_DARK_MODE = `${UI}/toggleDarkMode`;
export type TOGGLE_DARK_MODE = typeof TOGGLE_DARK_MODE;

export const DARK_MODE_CONFIRMED = `${UI}/darkModeConfirmed`;
export type DARK_MODE_CONFIRMED = typeof DARK_MODE_CONFIRMED;
